export enum EnumDisableOrActive{
  DISABLE = 0,
  ACTIVE
}

export type DisableOrActive = "disable" | "active";

export enum EnumDisableOrActiveStr{
  DISABLE = "disable",
  ACTIVE ="active"
}
